import { LicenseBinding } from "src/models/license";
import { createEntityModel } from "src/store/models/entity/_shared";

export const RpaLicenseBindingEntityModel = createEntityModel<LicenseBinding>();
